import { render, staticRenderFns } from "./DictionaryGroupEnumEditPage.vue?vue&type=template&id=48f21791&scoped=true&"
import script from "./DictionaryGroupEnumEditPage.vue?vue&type=script&lang=js&"
export * from "./DictionaryGroupEnumEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f21791",
  null
  
)

export default component.exports